// extracted by mini-css-extract-plugin
export default {"container":"ProcodocsNotifications_container__NAO+I","item":"ProcodocsNotifications_item__Biz4i","active":"ProcodocsNotifications_active__blOXf"};